import React from "react";
import BlocksArrayEditor from "./BlocksArrayEditor";

export default function BlocksContainerEditor({ title = "Blocks", container, path, updateAtPath }) {
    const blocks = container?.blocks || [];

    const setBlocks = (nextBlocks) => updateAtPath([...path, "blocks"], nextBlocks);

    return (
        <div className='d-grid gap-8 m-10'>
            {title ? <h3 className='mb-2'>{title}</h3> : null}

            <BlocksArrayEditor blocks={blocks} onChange={setBlocks} />
        </div>
    );
}
